/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import {
    Heading,
    FlexRow,
    FlexCol,
    ContentContainerBodyShift,
    TextBlock,
    useWindowSize,
    BREAKPOINTS,
} from 'sarsaparilla';

const linkItems = [
    {
        title: 'Choose Your Forest',
        description:
            'Determine which participating forest works best for your Christmas tree outing. Each forest will have specific guidelines and season dates for cutting a Christmas tree.',
        icon: 'ico1.svg',
    },
    {
        title: 'Get the Details',
        description:
            'Be safe and prepared. Carefully read the details and rules of your permit, and follow the Need to Know suggestions to prepare for your visit.',
        icon: 'ico2.svg',
    },
    {
        title: 'Buy a Permit',
        description:
            'Purchase and print your permit so you’re ready to find your perfect Christmas tree.',
        icon: 'ico3.svg',
    },
];

export default function FindingTree() {
    const { width } = useWindowSize();

    return (
        <ContentContainerBodyShift className="mt-5">
            <div className="tree-permit-finding-container">
                <section className="tree-permit-finding-wrap mb-0 mb-md-6">
                    <FlexRow>
                        <FlexCol className="tree-permit-finding-wrap-text mb-4">
                            <p className="tree-permit-finding-wrap mb-2">
                                A memorable experience, cutting a Christmas tree is a
                                special tradition to share with family and friends while
                                helping to maintain a healthy forest. For many families,
                                venturing into the forest to cut a Christmas tree for the
                                holidays is a treasured tradition carried on for
                                generations, while others may just be discovering the
                                thrill of searching for the perfect holiday centerpiece.
                            </p>
                            <p className="tree-permit-finding-wrap">
                                For every tree that is found, cut and carried home as a
                                holiday fixture, you&apos;re also contributing to the
                                overall forest health. Christmas tree permits are a unique
                                opportunity to help thin densely populated stands of
                                small-diameter trees - the perfect size for a Christmas
                                tree.
                            </p>
                        </FlexCol>
                    </FlexRow>
                    <FlexRow>
                        <FlexCol xs={12}>
                            <Heading
                                headingLevel={2}
                                appearance="h4"
                                hasUnderline="left"
                                className="mb-1"
                            >
                                How It Works
                            </Heading>
                        </FlexCol>

                        <FlexCol className="tree-permit-finding-wrap-text">
                            <TextBlock width="xl">
                                <p className="mb-3">
                                    Purchase your Christmas tree permit in advance of your
                                    visit to the forest in your area. Use this site to
                                    purchase your permit, follow tips and guidelines for
                                    the cutting area, and ensure you are prepared for a
                                    safe and fun forest adventure.
                                </p>
                            </TextBlock>
                        </FlexCol>
                    </FlexRow>
                    <FlexRow>
                        <FlexCol xs={12} lg={6} xl={5}>
                            {width && width <= BREAKPOINTS.lg ? (
                                <img
                                    className="tree-permit-finding-image mb-3"
                                    src={`${process.env.CDN}/img/where-to-cut-sm.jpg`}
                                    alt="A person in a blue snow jacket cuts a Christmas tree in the the snow"
                                />
                            ) : (
                                <img
                                    className="tree-permit-finding-image"
                                    src={`${process.env.CDN}/img/where-to-cut.jpg`}
                                    alt="A person in a blue snow jacket cuts a Christmas tree in the the snow"
                                />
                            )}
                        </FlexCol>
                        <FlexCol className="tree-permit-finding-wrap-facts">
                            {linkItems.map((linkItem, i) => {
                                return (
                                    <FlexRow key={i} hasGutters={false} className="mb-2">
                                        <FlexCol xs="variable">
                                            <div className="mr-2">
                                                <img
                                                    src={`${process.env.CDN}/img/${linkItem.icon}`}
                                                    alt="" // alt desc not needed for decorative images
                                                    aria-label={linkItem.title}
                                                />
                                            </div>
                                        </FlexCol>
                                        <FlexCol
                                            xs="auto"
                                            className="tree-permit-finding-text-wrap"
                                        >
                                            <Heading headingLevel={3} appearance="h5">
                                                {linkItem.title}
                                            </Heading>
                                            <div>
                                                <p>{linkItem.description}</p>
                                            </div>
                                        </FlexCol>
                                    </FlexRow>
                                );
                            })}
                        </FlexCol>
                    </FlexRow>
                </section>
            </div>
        </ContentContainerBodyShift>
    );
}
